export default __webpack_public_path__ + "static/banner_populus-303c994195c950758e81d0f2dd4f684d.jpg";